function globalAnimation() {
	this.sections = [];
	this.initialPosition = 100;
	this.targetPosition = 0;
	this.animationSpeed = 800;
	this.animationDelay = 100;
	this.options = {
		root: null,
		rootMargin: '0px',
		threshold: 0,
	};
	this.ignoredACFBlocks = [
		':not([class*="block-cta-standard"])',
	];
	this.animatableSections = [
		`#page section.acf-block${this.ignoredACFBlocks.join('')}`,
		'#page section.taxonomy-case-studies',
		'#page section.archive-case-studies',
		'#page section.staff-archive__top',
		'#page section.staff-archive__content',
		'#page [class*="hero"]:not([class*="__"]):not(.acf-block):not([class*="search"])',
	];

	this.sortAnimatables = (section) => {
		const animatables = [...section.children];

		animatables.sort((a, b) => {
			const condition =
				a.getBoundingClientRect().top - b.getBoundingClientRect().top;
			if (condition > 0) {
				return 1;
			}
			if (condition < 0) {
				return -1;
			}
			return 0;
		});

		const assignedIdBasedOnOffset = [];

		animatables.forEach((animatable) => {
			const initialStyle =
				this.extractTransformValuesFromComputedStyle(animatable);

			if (!animatable.getAttribute('data-init-transform')) {
				animatable.setAttribute(
					'data-init-transform',
					initialStyle.translateY
				);
			}

			assignedIdBasedOnOffset.push({
				style: initialStyle,
				element: animatable,
			});
		});

		return assignedIdBasedOnOffset;
	};

	this.extractTransformValuesFromComputedStyle = (element) => {
		const computedStyle = getComputedStyle(element);
		const transformMatrix = computedStyle.transform;
		const elementOpacity = parseFloat(computedStyle.opacity);

		if (!transformMatrix || transformMatrix === 'none') {
			return {
				opacity: elementOpacity,
				translateX: 0,
				translateY: 0,
			};
		}

		const matrixValues = transformMatrix
			.match(/[-\d.]+/g)
			.map((value) => parseFloat(value));

		return {
			opacity: elementOpacity,
			translateX: matrixValues[4],
			translateY: matrixValues[5],
		};
	};

	this.setup = () => {
		this.sections.forEach((section) => {
			const sortedAnimatables = this.sortAnimatables(section);

			sortedAnimatables.forEach((animatable) => {
				animatable.element.style.transition = null;
				animatable.element.style.opacity = 0;

				animatable.element.style.transform = `translate(
					${animatable.style.translateX}px,
					${animatable.style.translateY + this.initialPosition}px
				)`;

				const slightDelayForTransition = setTimeout(() => {
					animatable.element.style.transition = `transform ${this.animationSpeed}ms ease-in-out, opacity ${this.animationSpeed}ms ease-in-out`;
					clearTimeout(slightDelayForTransition);
				}, 0);
			});
		});
	};

	this.animate = (section) => {
		const sortedAnimatables = this.sortAnimatables(section);

		sortedAnimatables.forEach((animatable) => {
			const animationTimeout = setTimeout(() => {
				animatable.element.style.transform = `translate(
					${animatable.style.translateX}px,
					${animatable.element.getAttribute('data-init-transform')}px
				)`;

				const opacityDelay = setTimeout(() => {
					animatable.element.style.opacity = 1;
					clearTimeout(opacityDelay);
				}, this.animationDelay / 2);

				const removeStyleTimeout = setTimeout(() => {
					animatable.element.style.transform = null;
					animatable.element.style.transition = null;
					animatable.element.style.opacity = null;
					animatable.element.removeAttribute('data-init-transform');
					clearTimeout(removeStyleTimeout);
				}, this.animationSpeed + 100);

				clearTimeout(animationTimeout);
			}, this.animationDelay);
		});
	};

	this.observe = (sections) => {
		let topSet = false;

		const observer = new IntersectionObserver((entries) => {
			if (!topSet && window.scrollY <= 100) {
				topSet = true;
				window.scrollTo(0, 0);
			}
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					this.animate(entry.target);
					observer.unobserve(entry.target);
				}
			});
		}, this.options);

		sections.forEach((section) => {
			observer.observe(section);
		});
	};

	this.finishSetup = () => {
		const page = document.getElementById('page');

		if (page) {
			page.classList.add('page-animated');
		}
	};

	this.init = () => {
		if (this.sections.length === 0) {
			this.sections = document.querySelectorAll(this.animatableSections);
		}

		if (window.location.pathname === '/contact/') {
			this.finishSetup();
		} else {
			this.setup();
			this.finishSetup();
			
			const observeTimeout = setTimeout(() => {
				this.observe(this.sections);
				clearTimeout(observeTimeout);
			}, 10);
		}
	};

	return this;
}

export default new globalAnimation();
